export default "__VITE_ASSET__DTDiw7Hl__"